






import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import TelefonoModel from "@/models/telefono.model";
import PersonaTelefono from "@/models/persona/personaTelefono.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import EditarTelefono from "@/components/telefono/editarTelefono.vue";

@Component({
  components: { EditarTelefono }
})
export default class PerfilCiudadanoListaTelefonos extends BaseVue {
  @Prop() readonly personaId!: number;
  protected repository!: BaseRepository<PersonaTelefono>;

  constructor() {
    super();
    this.repository = new BaseRepository<PersonaTelefono>("personatelefono");
  }
 
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp("personaId", "number")
    );
    this.$emit("render", props);
  }
  onAdd(added: PersonaTelefono) {}

  editar() {}

  quitar() {
    this.$buefy.dialog.confirm({
      title: "Confirmación",
      message: "¿Desea eliminar este teléfono?",
      confirmText: "Adelante!",
      cancelText: "Cancelar",
      type: "is-danger",
      size: "is-medium",
      hasIcon: true,
      onConfirm: () => this.eliminar(0)
    });
  }

  async eliminar(telefonoId:number) {
    try {
      await this.repository.delete(telefonoId);
      this.operationSuccess("Teléfono eliminado!");
      //this.$emit('remove', id, data, props);
    } catch (e) {
      this.operationFailed(e);
    }
  }
}
